import { apiFunction } from "../../apiCall/function"

export const updateApplication = async (data) => {
  return await apiFunction("form/application", "post", data, true, 'body')
}

export const getApplication = async () => {
  return await apiFunction("form/application", "get", {}, true, 'body')
}